import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _ConfigAdmin, _CostingCenter } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { toast } from 'react-toastify';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';
import Select from 'react-select';

interface Props {
    idSelector?: number;
    onChange?: any;
    label?: string;
    returnType?: "ID" | "Object";
    fKey?: "Code" | "IDCostingCenter";
}

export const CostingCenterSelect = ({ idSelector, onChange, label, returnType = "ID", fKey = "IDCostingCenter" }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_CostingCenter);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties[fKey] === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties[fKey],
                    label: `${found.DataBeanProperties.Code}-${found.DataBeanProperties.Name}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);


    const getLista = () => {

        let cache = _single.getCacheItem("costinglist");
        if (cache) {
            setLista(cache);
        } else {
            instance.getCostingCenterCatalog(null).then(
                (resp: any) => {
                    if (resp) {
                        setLista(resp);
                        _single.setCacheItem("costinglist", resp);
                    }
                }
            ).catch(
                err => { toast.error(err) }
            )
        }

    }

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties[fKey],
        label: `${item.DataBeanProperties.Code}-${item.DataBeanProperties.Name}`,
        item: item
    }));

    return (
        <>
            {label && label != " " &&
                < label > {label ?? "Centro de Costo"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Seleccione un Centro de Costo"
                noOptionsMessage={() => "Sin coincidencias"}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                    menuPortal: base => ({ ...base, zIndex: 1100 })
                }}
            />
        </>
    )
}